/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { Modal } from '../../../../components';

import Navigation from './Navigation';
import EditSeminar from '../../containers/details/EditSeminar';
import VisitorsList from './VisitorsList';

import type { NavigationItems, ModalDialog, Seminar } from './Navigation';

type SeminarDetailsProps = {
    seminar: Seminar,
} & ModalDialog;

function SeminarDetails({ seminar, trigger, onClose, open }: SeminarDetailsProps) {
    const [selectedItem, setSelectedItem] = useState('editSeminar');

    const onItemClick = useCallback((e, { name }) => {
        setSelectedItem(name);
    }, []);

    return (
        <Modal onClose={onClose} open={open} trigger={trigger}>
            <Modal.Header>{seminar.name}</Modal.Header>
            <Navigation selectedItem={selectedItem} onItemClick={onItemClick} />
            {selectedItem === 'editSeminar' && (
                <EditSeminar seminar={seminar} onClose={onClose} />
            )}
            {selectedItem === 'visitorsList' && (
                <VisitorsList seminar={seminar} onClose={onClose} />
            )}
        </Modal>
    );
}

export default SeminarDetails;
